// Fora do rede-layout.tsx de propósito: as rotas (bundle inicial) leem a
// permissão de cada aba, e importar do layout puxaria o chunk lazy junto
// (mesmo cuidado de `financeiro/abas-financeiro.ts`).
export interface AbaRede {
  to: string
  label: string
  requiresPermission: string
  /** Vendedor interno não faz parte da árvore: só a aba "Minha rede" (§4.8). */
  naoParaVendedorInterno?: boolean
  /** A aba mostra números da apuração: só aparece com `rede.apuracao.habilitada` ligada (sonda de capacidades). */
  requerApuracao?: boolean
  /** A aba mostra extratos de pagamento: só aparece com `rede.pagamento.habilitado` ligada (sonda de capacidades). */
  requerPagamento?: boolean
  /** A aba é a visão da REDE INTEIRA (admin, diretoria, expansão, financeiro): consultor não a vê. */
  soVisaoDaRede?: boolean
}

export const ABAS_REDE: AbaRede[] = [
  { to: '/rede', label: 'Minha rede', requiresPermission: 'rede:ver' },
  { to: '/rede/consultores', label: 'Consultores', requiresPermission: 'rede:ver', naoParaVendedorInterno: true },
  // REDE-30 PR2c-1: as cooperativas-raiz com o titular de cada uma. Leitura da GESTÃO (a rota só responde ao escopo
  // TUDO): consultor e vendedor interno não veem a aba. Definir/trocar/remover titular é da diretoria, dentro dela.
  { to: '/rede/cooperativas', label: 'Cooperativas', requiresPermission: 'rede:ver', naoParaVendedorInterno: true, soVisaoDaRede: true },
  // REDE-16: as duas telas da apuração. Sem a flag de apuração a aba nem aparece (nada de "Em breve").
  { to: '/rede/metas', label: 'Metas e comissão', requiresPermission: 'rede:ver', naoParaVendedorInterno: true, requerApuracao: true },
  // REDE-22: os indicadores do ESCOPO de quem lê (spec §5: rede / subárvore / próprios — o vendedor
  // interno também vê os dele). Leem as placas que a apuração captura: sem a flag, a aba nem aparece.
  { to: '/rede/indicadores', label: 'Indicadores', requiresPermission: 'rede:ver', requerApuracao: true },
  {
    to: '/rede/fechamento',
    label: 'Fechamento',
    requiresPermission: 'rede:ver',
    naoParaVendedorInterno: true,
    requerApuracao: true,
    soVisaoDaRede: true,
  },
  // REDE-20: a fila do financeiro (extrato do dia cinco → NF → título → pago). Permissão PRÓPRIA
  // (`rede:financeiro`, REDE-04): diretoria e expansão não a têm. Sem a flag de pagamento a aba nem aparece.
  { to: '/rede/extratos', label: 'Extratos', requiresPermission: 'rede:financeiro', naoParaVendedorInterno: true, requerPagamento: true },
  // Q7 (dono, 06/10/2026): permissão PRÓPRIA, só da diretoria comercial (e do
  // admin, pelo curinga). Leitura informativa — não é ação crítica.
  { to: '/rede/permissoes', label: 'Permissões', requiresPermission: 'rede:permissoes' },
]

export function permissaoDaAba(to: string): string {
  const aba = ABAS_REDE.find((a) => a.to === to)
  if (!aba) throw new Error(`aba da rede desconhecida: ${to}`)
  return aba.requiresPermission
}
